// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export { $delete } from "./operations.js";
export type { RegisteredIdentitiesDeleteOptionalParams } from "./options.js";
